const labels = {
  "eyes": "עיניים",
  "Real people. Playful beginnings.": "אנשים אמיתיים. התחלות עם חיוך.",
  "A little mystery.": "קצת מסתורין.",
  "A lot of chemistry.": "המון כימיה.",
  "AFTER HOURS / 01": "אחרי שעות / 01",
  "PRISM / 02": "פריזמה / 02",
  "Talk": "מדברים",
  "Reveal": "נחשפים",
  "Make a date": "קובעים דייט",
  "Account options": "אפשרויות חשבון",
  "Create an account": "יצירת חשבון",
  "Sign in": "כניסה",
  "Sign In": "כניסה",
  "Contact Us": "יצירת קשר",
  "Retry saved filters": "טעינת הפילטרים השמורים מחדש",
  "A little anticipation.": "ההתרגשות כבר כאן.",
  "Waiting time": "זמן המתנה",
  "Cancel": "ביטול",
  "Match Found!": "מצאנו התאמה!",
  "You've been matched with": "יש לכם התאמה עם",
  ", Age": ", גיל",
  "Waiting for your partner…": "ממתינים לצד השני…",
  "I’m ready": "אפשר להתחיל",
  "Leave conversation": "יציאה מהשיחה",
  "Break the ice together": "שוברים את הקרח ביחד",
  "remaining": "נותרו",
  "Your microphone is muted.": "המיקרופון שלכם מושתק.",
  "Your microphone is on.": "המיקרופון שלכם פעיל.",
  "You": "אתם",
  "Partner": "הצד השני",
  "I’m ready to reveal": "אפשר להיחשף",
  "Close filters": "סגירת הפילטרים",
  "Loading face tracking…": "טוענים זיהוי פנים…",
  "Waiting for your camera…": "ממתינים למצלמה…",
  "Camera playback paused.": "תצוגת המצלמה מושהית.",
  "Resume camera": "הפעלת המצלמה מחדש",
  "Face tracking is unavailable.": "זיהוי הפנים אינו זמין.",
  "Retry face tracking": "ניסיון נוסף לזיהוי פנים",
  "Meet each other.": "נעים להכיר.",
  "Revealed": "נחשפתם",
  "Microphone muted": "המיקרופון מושתק",
  "Audio stays on": "השיחה הקולית ממשיכה",
  "You and": "אתם וגם",
  "Keep the story going": "ממשיכים את הסיפור",
  "Back to Lobby": "חזרה למסך הראשי",
  "Your partner is reconnecting…": "הצד השני מנסה להתחבר מחדש…",
  "Video stage timer": "הזמן שנותר בשלב הווידאו",
  "Call menu": "תפריט שיחה",
  "Show session info": "הצגת פרטי השיחה",
  "Hide session info": "הסתרת פרטי השיחה",
  "Exit fullscreen": "יציאה ממסך מלא",
  "Fullscreen": "מסך מלא",
  "Filters": "פילטרים",
  "Voice": "קול",
  "Voice effect": "אפקט קולי",
  "Please sign in again.": "יש להיכנס לחשבון מחדש.",
  "Authentication required.": "נדרשת כניסה לחשבון.",
  "Reconnecting": "מתחברים מחדש",
  "In queue...": "ממתינים להתאמה…",
  "Not connected to server": "אין חיבור לשרת",
  "Profile update failed.": "עדכון הפרופיל נכשל.",
  "your match": "ההתאמה שלכם",
  "Male": "גבר",
  "Female": "אישה",
  "Other": "אחר",
  "Men": "גברים",
  "Women": "נשים",
  "Age": "גיל",
  "Gender": "מגדר",
  "City": "יישוב",
  "Username": "שם משתמש",
  "Password": "סיסמה",
  "Email": "דוא״ל",
  "Bio": "קצת עליי",
  "Phone Number": "מספר טלפון",
  "Interests": "תחומי עניין",
  "Select gender": "בחירת מגדר",
  "Select preference": "בחירת העדפה",
  "I'm interested in": "מעניין אותי להכיר",
  "Almost done! 👋": "כמעט סיימנו! 👋",
  "Save & Continue": "שמירה והמשך",
  "Skip for now": "דילוג לעת עתה",
  "Close profile": "סגירת הפרופיל",
  "Edit profile": "עריכת פרופיל",
  "Profile": "פרופיל",
  "My Profile": "הפרופיל שלי",
  "Edit Details": "עריכת פרטים",
  "Close": "סגירה",
  "Profile Picture": "תמונת פרופיל",
  "📷 Change Photo": "📷 החלפת תמונה",
  "Choose profile photo": "בחירת תמונת פרופיל",
  "Personal Details": "פרטים אישיים",
  "Your username": "שם המשתמש שלכם",
  "Select…": "בחירה…",
  "Match Preferences": "העדפות היכרות",
  "I'm looking for…": "אשמח להכיר…",
  "Preferred Age Range": "טווח גילאים מועדף",
  "Save Profile": "שמירת פרופיל",
  "Close sign in": "סגירת חלון הכניסה",
  "CONNEXT · WELCOME BACK": "CONNEXT · טוב שחזרתם",
  "Your next chapter.": "הפרק הבא שלכם.",
  "Starts here.": "מתחיל כאן.",
  "Forgot your password?": "שכחתם את הסיסמה?",
  "Signing in...": "נכנסים לחשבון…",
  "Opening your next chapter…": "פותחים את הפרק הבא שלכם…",
  "or continue with": "או ממשיכים עם",
  "Reset Password": "איפוס סיסמה",
  "Send reset link": "שליחת קישור לאיפוס",
  "Back to sign in": "חזרה לכניסה",
  "Register": "הרשמה",
  "Close signup": "סגירת חלון ההרשמה",
  "Something real.": "משהו אמיתי.",
  "Starts with you.": "מתחיל בכם.",
  "or sign up with": "או נרשמים עם",
  "Resend verification email": "שליחת הודעת האימות מחדש",
  "Your introduction": "נעים להכיר",
  "Start with the essentials.": "מתחילים בפרטים הבסיסיים.",
  "Email (optional, for verification)": "דוא״ל (לא חובה, לצורך אימות)",
  "Your kind of connection": "החיבור שמתאים לכם",
  "Looking for": "אשמח להכיר",
  "Looking for...": "אשמח להכיר…",
  "I'm looking for...": "אשמח להכיר…",
  "Interests (": "תחומי עניין (",
  "selected)": "נבחרו)",
  "Age Range": "טווח גילאים",
  "Min:": "מגיל:",
  "- Max:": "— עד גיל:",
  "A little more you": "עוד קצת עליכם",
  "Profile Image": "תמונת פרופיל",
  "Creating your account…": "יוצרים את החשבון שלכם…",
  "Create my account": "יצירת החשבון שלי",
  "📧 Verify Your Email": "📧 אימות כתובת הדוא״ל",
  "Enter 5-digit code": "הזינו קוד בן 5 ספרות",
  "Verification Code": "קוד אימות",
  "Verification failed": "האימות נכשל",
  "Verify Email": "אימות דוא״ל",
  "Resend code": "שליחת הקוד מחדש",
  "✅ Email Verified!": "✅ הדוא״ל אומת!",
  "Blocked users": "חשבונות חסומים",
  "Loading blocked users…": "טוענים את רשימת החסומים…",
  "Reload list": "טעינת הרשימה מחדש",
  "You haven’t blocked anyone.": "אין חשבונות חסומים.",
  "Unblock": "הסרת חסימה",
  "Reconnecting your call…": "מתחברים מחדש לשיחה…",
  "Conversation progress": "התקדמות השיחה",
  "Your connection starts here": "החיבור שלכם מתחיל כאן",
  "Voice first": "מתחילים בקול",
  "A little mystery": "קצת מסתורין",
  "Meet each other": "נעים להכיר",
  "Call controls": "פקדי שיחה",
  "Unmute microphone": "ביטול השתקת המיקרופון",
  "Mute microphone": "השתקת המיקרופון",
  "Listening": "מקשיבים",
  "Unmute": "ביטול השתקה",
  "Mic on": "המיקרופון פעיל",
  "Volume": "עוצמת קול",
  "Partner volume": "עוצמת הקול של הצד השני",
  "Report": "דיווח",
  "End call": "סיום שיחה",
  "End Call": "סיום שיחה",
  "Leave": "יציאה",
  "Chat": "צ׳אט",
  "Reload conversation": "טעינת השיחה מחדש",
  "Message": "הודעה",
  "Type a message...": "כתבו הודעה…",
  "Send": "שליחה",
  "Waiting for location permission…": "ממתינים לאישור הגישה למיקום…",
  "Finding a nearby city…": "מחפשים יישוב קרוב…",
  "Finding your city…": "מאתרים את היישוב שלכם…",
  "Use my location": "שימוש במיקום שלי",
  "Search Israeli cities": "חיפוש יישובים בישראל",
  "Loading cities…": "טוענים יישובים…",
  "Could not load cities.": "לא ניתן לטעון את רשימת היישובים.",
  "Retry": "ניסיון נוסף",
  "Making a little connection…": "יוצרים חיבור קטן…",
  "Hello again.": "טוב לראות אתכם שוב.",
  "Finding someone to meet.": "מחפשים מישהו להכיר.",
  "There you are.": "הנה אתם.",
  "Voice first.": "מתחילים בקול.",
  "Hello, you.": "היי, נעים להכיר.",
  "A spark worth keeping.": "ניצוץ ששווה לשמור.",
  "Your connection is saved.": "החיבור שלכם נשמר.",
  "Make it a date.": "הופכים את זה לדייט.",
  "📧 Contact Us": "📧 יצירת קשר",
  "Website": "אתר",
  "A little inspiration": "קצת השראה",
  "Another question": "שאלה נוספת",
  "Plan a date": "תכנון דייט",
  "It’s a date!": "יש דייט!",
  "Two ideas. One date.": "שתי הצעות. דייט אחד.",
  "Date planning progress": "התקדמות תכנון הדייט",
  "Pick your plans": "מציעים דייט",
  "Vote together": "מצביעים יחד",
  "It’s a date": "יש דייט",
  "Refresh": "רענון",
  "Your plan": "ההצעה שלכם",
  "Their plan": "ההצעה של הצד השני",
  "THE SPOT": "המקום",
  "/ 2 votes": "/ 2 הצבעות",
  "Your vote": "ההצבעה שלכם",
  "Vote for this plan": "הצבעה להצעה הזאת",
  "Confirmed together": "אושר יחד",
  "Your kind of date.": "הדייט שמתאים לכם.",
  "Waiting for a suggestion": "ממתינים להצעה",
  "Edit your plan": "עריכת ההצעה שלכם",
  "Build your plan": "יצירת ההצעה שלכם",
  "Place to meet": "מקום למפגש",
  "Date and time": "תאריך ושעה",
  "Suggest my plan": "שליחת ההצעה שלי",
  "Private camera preview": "תצוגת מצלמה פרטית",
  "Microphone level": "עוצמת המיקרופון",
  "Checking devices…": "בודקים מצלמה ומיקרופון…",
  "Test camera & microphone": "בדיקת מצלמה ומיקרופון",
  "Play test sound": "השמעת צליל בדיקה",
  "Join the queue": "תחילת חיפוש התאמה",
  "Back": "חזרה",
  "Meet. Vibe.": "מכירים. מתחברים.",
  "See where it goes.": "רואים לאן זה זורם.",
  "Let’s meet": "בואו נכיר",
  "My chats": "השיחות שלי",
  "Filter Workshop": "סדנת פילטרים",
  "All": "הכול",
  "My filters": "הפילטרים שלי",
  "Studio": "סטודיו",
  "Animals": "חיות",
  "Fantasy": "פנטזיה",
  "Color & light": "צבע ואור",
  "Abstract": "מופשט",
  "Classics": "קלאסיקות",
  "Find your look": "מוצאים את הלוק שלכם",
  "Search face filters": "חיפוש פילטרים לפנים",
  "Try cat, crown, colorful…": "נסו חתול, כתר, צבעוני…",
  "Filter categories": "קטגוריות פילטרים",
  "Cosmic crush": "קראש מהחלל",
  "Love at first doodle": "אהבה משרבוט ראשון",
  "Moonlight magic": "קסם באור הירח",
  "My look": "הלוק שלי",
  "Starting camera…": "מפעילים את המצלמה…",
  "Draw your signature touch": "הוסיפו ציור אישי",
  "Mix two colours": "שלבו שני צבעים",
  "Workshop preview": "תצוגת הסדנה",
  "Camera off": "המצלמה כבויה",
  "Close workshop": "סגירת הסדנה",
  "Camera preview": "תצוגת מצלמה",
  "Move camera preview": "הזזת תצוגת המצלמה",
  "⠿ Move preview": "⠿ הזזת התצוגה",
  "Exit fullscreen preview": "יציאה מתצוגה במסך מלא",
  "Fullscreen preview": "תצוגה במסך מלא",
  "Custom filter live preview": "תצוגה חיה של הפילטר האישי",
  "Camera unavailable": "המצלמה אינה זמינה",
  "Retry camera": "ניסיון נוסף להפעלת המצלמה",
  "Base face filter": "פילטר בסיס לפנים",
  "None": "ללא",
  "Creative tools": "כלי יצירה",
  "✦ Shapes & stickers": "✦ צורות ומדבקות",
  "✎ Draw": "✎ ציור",
  "Undo": "ביטול פעולה",
  "Redo": "ביצוע חוזר",
  "Sticker tray": "מגש מדבקות",
  "Filter name": "שם הפילטר",
  "Layer": "שכבה",
  "Drawing": "ציור",
  "Add layer": "הוספת שכבה",
  "Shape": "צורה",
  "Attach to": "הצמדה אל",
  "Left eye": "עין שמאל",
  "Right eye": "עין ימין",
  "Colour": "צבע",
  "Colour palette": "פלטת צבעים",
  "Opacity": "אטימות",
  "Horizontal position": "מיקום אופקי",
  "Vertical position": "מיקום אנכי",
  "Size": "גודל",
  "Rotation": "סיבוב",
  "Duplicate layer": "שכפול שכבה",
  "Bring forward": "העברה קדימה",
  "Send backward": "העברה אחורה",
  "Reset position": "איפוס מיקום",
  "Remove layer": "הסרת שכבה",
  "Creative challenge": "אתגר יצירתי",
  "/ 3 BADGES": "/ 3 תגים",
  "Challenge progress": "התקדמות האתגר",
  "★ Badge earned!": "★ הרווחתם תג!",
  "Claim creative badge": "קבלת תג יצירה",
  "Next challenge": "לאתגר הבא",
  "You earned the": "הרווחתם את התג",
  "Use a saved filter": "שימוש בפילטר שמור",
  "Choose from My filters": "בחירה מהפילטרים שלי",
  "Save & use filter": "שמירה ושימוש בפילטר",
  "Dismiss notification": "סגירת ההתראה",
  "Face filters": "פילטרים לפנים",
  "No filter": "ללא פילטר",
  "View profile": "צפייה בפרופיל",
  "Private match chat": "שיחה פרטית עם ההתאמה",
  "Request phone call": "בקשה לשיחה קולית",
  "Request video call": "בקשה לשיחת וידאו",
  "Report this user": "דיווח על החשבון",
  "Waiting for": "ממתינים ל־",
  "to accept your call…": "לאישור השיחה…",
  "Failed to load matches.": "טעינת ההתאמות נכשלה.",
  "💕 Your Matches": "💕 ההתאמות שלכם",
  "Picking up the conversation…": "חוזרים לשיחה…",
  "Loading your matches": "טוענים את ההתאמות שלכם",
  "No matches yet": "עדיין אין התאמות",
  "• Matched": "• התאמה מתאריך",
  "Say hello! 👋": "תגידו שלום! 👋",
  "Open chat": "פתיחת שיחה",
  "Your partner is ready": "הצד השני מוכן",
  "Your partner": "הצד השני",
  "Your match": "ההתאמה שלכם",
  "Notifications": "התראות",
  "Date invitation": "הזמנה לדייט",
  "Dismiss date invitation": "סגירת ההזמנה לדייט",
  "suggested a date at": "הציעו דייט ב־",
  "Incoming call": "שיחה נכנסת",
  "Incoming": "נכנסת",
  "call": "שיחה",
  "Accept call": "מענה לשיחה",
  "Decline": "דחייה",
  "Could not load profile.": "לא ניתן לטעון את הפרופיל.",
  "Loading profile…": "טוענים פרופיל…",
  "About": "קצת עליי",
  "Close date planner": "סגירת מתכנן הדייט",
  "Suggest a date": "הצעת דייט",
  "💔 Unmatch": "💔 ביטול התאמה",
  "Calling...": "מתקשרים…",
  "seconds remaining": "שניות נותרו",
  "Camera playback paused": "תצוגת המצלמה מושהית",
  "Loading your face filter…": "טוענים את הפילטר שלכם…",
  "Face filter unavailable": "הפילטר אינו זמין",
  "Face filter interrupted": "הפילטר נקטע",
  "Video stopped": "הווידאו נעצר",
  "Nudity or sexual content": "עירום או תוכן מיני",
  "Abusive or offensive language": "שפה פוגענית או מעליבה",
  "Harassment or bullying": "הטרדה או בריונות",
  "Violence or threatening behavior": "אלימות או התנהגות מאיימת",
  "Drugs or illegal substances": "סמים או חומרים לא חוקיים",
  "Hate speech or discrimination": "דברי שנאה או אפליה",
  "Fake profile or impersonation": "פרופיל מזויף או התחזות",
  "Spam or solicitation": "ספאם או פניות מסחריות לא רצויות",
  "Please select a reason": "יש לבחור סיבה",
  "Failed to submit report": "שליחת הדיווח נכשלה",
  "Close report": "סגירת הדיווח",
  "You’re in control.": "השליטה בידיים שלכם.",
  "Your comfort comes first.": "הנוחות שלכם קודמת לכול.",
  "Your report for": "הדיווח שלכם על",
  "Done": "סיום",
  "What happened?": "מה קרה?",
  "Report & block": "דיווח וחסימה",
  "Set a Date": "קביעת דייט",
  "Pick a Date": "בחירת תאריך",
  "Time": "שעה",
  "Location": "מיקום",
  "Confirm Date 💕": "אישור הדייט 💕",
  "✦ ICEBREAKER ROULETTE": "✦ רולטת שאלות היכרות",
  "Voted · 1/2": "הצבעתם · 1/2",
  "Vote for another question": "הצבעה לשאלה אחרת",
  "Authentication is not configured.": "הכניסה לחשבון אינה זמינה כרגע.",
  "Continue with Google": "המשך עם Google",
  "Continue with Apple": "המשך עם Apple",
  "Signing you in…": "מחברים אתכם לחשבון…",
  "📋 Terms of Use": "📋 תנאי שימוש",
  "I acknowledge the": "קראתי את",
  "Privacy Policy": "מדיניות הפרטיות",
  "✅ Create Account": "✅ יצירת חשבון",
  "Good places. Better company.": "מקומות טובים. חברה עוד יותר טובה.",
  "Your cities": "היישובים שלכם",
  "Venue categories": "קטגוריות מקומות",
  "Finding places…": "מחפשים מקומות…",
  "Sponsored places": "מקומות ממומנים",
  "In the spotlight": "בזרקור",
  "In and around": "ביישוב ובסביבה:",
  "Coverage varies by city.": "המידע הזמין משתנה בין היישובים.",
  "© OpenStreetMap contributors": "© תורמי OpenStreetMap",
  "Restaurants": "מסעדות",
  "Bars": "ברים",
  "Music & theatre": "מוזיקה ותיאטרון",
  "Parks": "פארקים",
  "Loading photo…": "טוענים תמונה…",
  "Photo unavailable": "התמונה אינה זמינה",
  "Sponsored": "ממומן",
  "Source photo": "מקור התמונה",
  "km from centre": "ק״מ מהמרכז",
  "Paid placement by": "פרסום ממומן מטעם",
  "Open now": "פתוח עכשיו",
  "Closed now": "סגור עכשיו",
  "Opening hours": "שעות פתיחה",
  "Choose this place": "בחירת המקום הזה",
  "Google Maps ↗": "מפות Google ↗",
  "Google Maps": "מפות Google",
  "Business promotions": "קידום עסקים",
  "Your business spotlight": "העסק שלכם בזרקור",
  "Paused": "מושהה",
  "Ended": "הסתיים",
  "Scheduled": "מתוזמן",
  "Active": "פעיל",
  "Edit": "עריכה",
  "Pause": "השהיה",
  "Enable": "הפעלה",
  "Edit campaign": "עריכת קמפיין",
  "New campaign": "קמפיין חדש",
  "Business name": "שם העסק",
  "Paid for by": "הגורם המממן",
  "Full address": "כתובת מלאה",
  "Short invitation (optional)": "הזמנה קצרה (לא חובה)",
  "Business photo URL (HTTPS)": "קישור לתמונת העסק (HTTPS)",
  "Photo credit / owner": "קרדיט לתמונה / בעל הזכויות",
  "Map link (HTTPS)": "קישור למפה (HTTPS)",
  "Opening hours (optional)": "שעות פתיחה (לא חובה)",
  "Category": "קטגוריה",
  "Starts": "מתחיל",
  "Ends": "מסתיים",
  "(your time)": "(לפי השעה המקומית שלכם)",
  "Placement priority (0–100)": "עדיפות הצגה (0–100)",
  "Customer preview": "תצוגה מקדימה למשתמשים",
  "Save campaign": "שמירת קמפיין",
  "New / clear": "חדש / ניקוי",
  "Natural": "טבעי",
  "Warm": "חם",
  "Radio": "רדיו",
  "Robot": "רובוט",
  "Echo": "הד",
  "Drawing pad": "לוח ציור",
  "✎ Drawing tools": "✎ כלי ציור",
  "Brush presets": "סוגי מברשות",
  "Pencil": "עיפרון",
  "Brush": "מברשת",
  "Brush size": "גודל המברשת",
  "Mirror drawing": "ציור סימטרי",
  "Neon glow": "זוהר ניאון",
  "🎮 Gaming & Tech": "🎮 גיימינג וטכנולוגיה",
  "Gaming": "גיימינג",
  "PC Gaming": "משחקי מחשב",
  "Console Gaming": "משחקי קונסולה",
  "Mobile Gaming": "משחקים בנייד",
  "VR / AR": "מציאות מדומה ורבודה",
  "Coding": "תכנות",
  "AI & Tech": "בינה מלאכותית וטכנולוגיה",
  "Gadgets": "גאדג׳טים",
  "Cybersecurity": "אבטחת סייבר",
  "Crypto / Web3": "קריפטו ו־Web3",
  "🎬 Entertainment": "🎬 בידור",
  "Movies": "סרטים",
  "TV Series": "סדרות",
  "Anime": "אנימה",
  "Documentaries": "סרטים תיעודיים",
  "Stand-up Comedy": "סטנדאפ",
  "Podcasts": "פודקאסטים",
  "Streaming": "סטרימינג",
  "Theater": "תיאטרון",
  "Board Games": "משחקי קופסה",
  "🎵 Music": "🎵 מוזיקה",
  "Pop": "פופ",
  "Rock": "רוק",
  "Electronic / EDM": "מוזיקה אלקטרונית",
  "Jazz": "ג׳אז",
  "Classical": "מוזיקה קלאסית",
  "Metal": "מטאל",
  "Indie": "אינדי",
  "Playing Instruments": "נגינה",
  "🏃 Sports & Fitness": "🏃 ספורט וכושר",
  "Gym / Weightlifting": "חדר כושר והרמת משקולות",
  "Running": "ריצה",
  "Cycling": "רכיבה על אופניים",
  "Swimming": "שחייה",
  "Football / Soccer": "כדורגל",
  "Basketball": "כדורסל",
  "Tennis": "טניס",
  "Martial Arts": "אומנויות לחימה",
  "Yoga": "יוגה",
  "Hiking": "טיולים בטבע",
  "🌿 Outdoors & Nature": "🌿 טבע ושטח",
  "Camping": "קמפינג",
  "Rock Climbing": "טיפוס",
  "Surfing": "גלישה",
  "Skiing / Snowboarding": "סקי וסנובורד",
  "Fishing": "דיג",
  "Gardening": "גינון",
  "Bird Watching": "צפרות",
  "Astronomy": "אסטרונומיה",
  "Backpacking": "תרמילאות",
  "🍕 Food & Drink": "🍕 אוכל ושתייה",
  "Cooking": "בישול",
  "Baking": "אפייה",
  "Coffee": "קפה",
  "Wine": "יין",
  "Craft Beer": "בירות בוטיק",
  "Sushi": "סושי",
  "Vegan / Plant-based": "תזונה מהצומח",
  "Street Food": "אוכל רחוב",
  "Fine Dining": "מסעדות שף",
  "Meal Prep": "הכנת ארוחות מראש",
  "✈️ Travel & Culture": "✈️ טיולים ותרבות",
  "Travelling": "מסעות",
  "Road Trips": "טיולי דרכים",
  "Languages": "שפות",
  "History": "היסטוריה",
  "Museums": "מוזיאונים",
  "Photography": "צילום",
  "Architecture": "אדריכלות",
  "Volunteering": "התנדבות",
  "Festivals": "פסטיבלים",
  "📚 Learning & Creativity": "📚 למידה ויצירה",
  "Reading": "קריאה",
  "Writing": "כתיבה",
  "Drawing / Illustration": "ציור ואיור",
  "Painting": "ציור בצבע",
  "Sculpting": "פיסול",
  "Filmmaking": "יצירת סרטים",
  "Design": "עיצוב",
  "Fashion": "אופנה",
  "DIY / Crafts": "עשה זאת בעצמך ומלאכת יד",
  "🧘 Wellness & Lifestyle": "🧘 רווחה ואורח חיים",
  "Meditation": "מדיטציה",
  "Mindfulness": "קשיבות",
  "Journaling": "כתיבת יומן",
  "Astrology": "אסטרולוגיה",
  "Spirituality": "רוחניות",
  "Minimalism": "מינימליזם",
  "Sustainability": "קיימות",
  "Mental Health": "בריאות הנפש",
  "Nutrition": "תזונה",
  "🐾 Animals & Pets": "🐾 חיות ומחמד",
  "Dogs": "כלבים",
  "Cats": "חתולים",
  "Horses": "סוסים",
  "Reptiles": "זוחלים",
  "Birds": "ציפורים",
  "Marine Life": "חיים בים",
  "Wildlife": "חיות בר",
  "Animal Rescue": "הצלת בעלי חיים",
  "Veganism": "טבעונות",
  "Zoo / Aquarium": "גן חיות ואקווריום",
  "Pixelate": "פיקסלים",
  "Pixelates the face area": "הופך את אזור הפנים לפיקסלים",
  "Gaussian Blur": "טשטוש חלק",
  "Sunglasses": "משקפי שמש",
  "Clown": "ליצן",
  "Cat Ears": "אוזני חתול",
  "Heart Eyes": "עיני לב",
  "Replaces eyes with hearts": "מחליף את העיניים בלבבות",
  "Rainbow": "קשת",
  "Dog": "כלב",
  "Alien": "חייזר",
  "Fire": "אש",
  "Neon Glow": "זוהר ניאון",
  "Mosaic": "פסיפס",
  "Prism visor": "משקף פריזמה",
  "A glossy multicolour visor": "משקף מבריק בשלל צבעים",
  "Heart eyes": "עיני לב",
  "Electric": "חשמל",
  "Afterglow jewels": "תכשיטי זוהר",
  "Orbit": "מסלול",
  "Festival lights": "אורות פסטיבל",
  "Polar bear": "דוב קוטב",
  "Mint bunny": "ארנבון מנטה",
  "Peach cat": "חתול אפרסק",
  "Puppy": "כלבלב",
  "Cosmic cat": "חתול קוסמי",
  "Dalmatian": "דלמטי",
  "Bunny": "ארנבון",
  "Fox": "שועל",
  "Honey bear": "דוב דבש",
  "Panda": "פנדה",
  "Royal": "מלכותי",
  "Golden halo": "הילה זהובה",
  "Unicorn": "חד־קרן",
  "Butterflies": "פרפרים",
  "Flower crown": "זר פרחים",
  "Stardust": "אבק כוכבים",
  "Confetti": "קונפטי",
  "Rainbow sky": "שמיים וקשת",
  "Smoke": "עשן",
  "Amber": "ענבר",
  "Midnight": "חצות",
  "Pearl": "פנינה",
  "Constellation": "קבוצת כוכבים",
  "Already in queue": "כבר ממתינים להתאמה",
  "Authentication token required": "נדרשת התחברות לחשבון",
  "Call access denied": "אין גישה לשיחה",
  "Call access denied.": "אין גישה לשיחה.",
  "Call initiated": "השיחה החלה",
  "Call is not ready.": "השיחה עדיין אינה מוכנה.",
  "Campaign not found": "הקמפיין לא נמצא",
  "Cannot report yourself": "אי אפשר לדווח על עצמכם",
  "Choose a valid partner.": "בחרו התאמה תקינה.",
  "Choose plan or vote.": "בחרו הצעה או הצבעה.",
  "City is required": "יש לבחור יישוב",
  "Conversation access denied.": "אין גישה לשיחה.",
  "Conversation is unavailable.": "השיחה אינה זמינה.",
  "Current user not found": "המשתמש הנוכחי לא נמצא",
  "Date planning is unavailable.": "תכנון הדייט אינו זמין.",
  "Email already verified": "הדוא״ל כבר אומת",
  "Email is required": "יש להזין דוא״ל",
  "Email verified": "הדוא״ל אומת",
  "Email verified successfully": "הדוא״ל אומת בהצלחה",
  "File upload failed": "העלאת הקובץ נכשלה",
  "Image not found": "התמונה לא נמצאה",
  "Image uploaded successfully": "התמונה הועלתה בהצלחה",
  "Internal server error": "אירעה שגיאה בשרת",
  "Invalid base filter": "פילטר הבסיס אינו תקין",
  "Invalid blocked_id": "מזהה החסימה אינו תקין",
  "Invalid colour": "הצבע אינו תקין",
  "Invalid drawing": "הציור אינו תקין",
  "Invalid drawing point": "נקודת הציור אינה תקינה",
  "Invalid email address": "כתובת הדוא״ל אינה תקינה",
  "Invalid email or password": "הדוא״ל או הסיסמה שגויים",
  "Invalid filter": "הפילטר אינו תקין",
  "Invalid gender": "המגדר אינו תקין",
  "Invalid layer": "השכבה אינה תקינה",
  "Invalid location coordinates.": "נתוני המיקום אינם תקינים.",
  "Invalid opacity": "רמת האטימות אינה תקינה",
  "Invalid preferred gender": "העדפת המגדר אינה תקינה",
  "Invalid receiver_id": "מזהה הנמען אינו תקין",
  "Invalid request.": "הבקשה אינה תקינה.",
  "Invalid shape": "הצורה אינה תקינה",
  "Invalid token": "פרטי ההתחברות אינם תקינים",
  "Invalid verification code": "קוד האימות שגוי",
  "Left the queue": "יצאתם מחיפוש ההתאמה",
  "Location coordinates are required.": "נדרשים נתוני מיקום.",
  "Looking for a match...": "מחפשים התאמה…",
  "Match removed": "ההתאמה הוסרה",
  "Match removed successfully": "ההתאמה הוסרה בהצלחה",
  "Match session not found": "שיחת ההתאמה לא נמצאה",
  "Message sent": "ההודעה נשלחה",
  "Message text is required": "יש להזין תוכן להודעה",
  "Missing token": "חסרים פרטי התחברות",
  "No file part": "לא צורף קובץ",
  "No matches found": "לא נמצאו התאמות",
  "No selected file": "לא נבחר קובץ",
  "Owner access required": "נדרשת הרשאת בעלים",
  "Preferences updated successfully": "ההעדפות עודכנו בהצלחה",
  "Profile is unavailable": "הפרופיל אינו זמין",
  "Profile updated successfully": "הפרופיל עודכן בהצלחה",
  "Proposal access denied": "אין גישה להצעה",
  "Recipient not found": "הנמען לא נמצא",
  "Resource not found": "המשאב לא נמצא",
  "Room access denied.": "אין גישה לחדר השיחה.",
  "The conversation has ended.": "השיחה הסתיימה.",
  "This conversation has ended.": "השיחה הזאת הסתיימה.",
  "Token has expired": "תוקף ההתחברות פג",
  "User ID required": "נדרש מזהה משתמש",
  "User already reported": "כבר דיווחתם על המשתמש הזה",
  "User created successfully": "החשבון נוצר בהצלחה",
  "User not found": "המשתמש לא נמצא",
  "User reported successfully": "הדיווח נשלח בהצלחה",
  "User unblocked": "החסימה הוסרה",
  "Username already exists": "שם המשתמש כבר תפוס",
  "Verification code sent": "קוד האימות נשלח",
  "Suggested ": "היישוב המוצע: ",
  " is unblocked.": " — החסימה הוסרה.",
  "Unblock ": "הסרת חסימה עבור ",
  " declined your call.": " דחה/תה את השיחה.",
  " sent a message": " שלח/ה הודעה",
  " tried to call.": " ניסה/תה להתקשר.",
  "Dismiss ": "סגירת ",
  " yrs": " שנים",
  "Message ": "הודעה אל ",
  "Could not open ": "לא ניתן לפתוח את השיחה עם ",
  "’s profile photo": " — תמונת פרופיל",
  "Add a ": "הוסיפו מדבקת ",
  " sticker": "",
  "Add ": "הוספת מדבקת ",
  "Use ": "שימוש בצבע ",
  " out of 5, ": " מתוך 5, ",
  " Google reviews": " ביקורות ב־Google",
  "Listed hours: ": "שעות רשומות: ",
  "Directions to ": "הוראות הגעה אל ",
  " in Google Maps": " במפות Google",
  "Saving…": "שומרים…",
  "Sending…": "שולחים…",
  "Connecting…": "מתחברים…",
  "Joining…": "מצטרפים…",
  "Uploading…": "מעלים…",
  "Submitting…": "שולחים…",
  "Unblocking…": "מסירים חסימה…",
  "Unmatching...": "מבטלים התאמה…",
  "Verifying...": "מאמתים…",
  "Hip-Hop": "היפ־הופ",
  "Self-improvement": "התפתחות אישית",
  "📞 Call in progress…": "📞 שיחה פעילה…",
  "Video processing timed out": "עיבוד הווידאו נמשך זמן רב מדי",
  "Audio activation timed out": "הפעלת השמע נמשכה זמן רב מדי",
  "Peer connection is closed.": "החיבור לשיחה נסגר.",
  "male": "גבר",
  "female": "אישה",
  "other": "אחר",
  "forehead": "מצח",
  "nose": "אף",
  "mouth": "פה",
  "leftCheek": "לחי שמאל",
  "rightCheek": "לחי ימין",
  "face": "פנים",
  "phone": "קולית",
  "video": "וידאו"
};
export default function hebrewLabel(value) { return labels[value] || value; }
